export const appNavigation = [
  {title: 'Знакомство', src: 'usage'},
  {title: 'Возможности', src: 'ability'},
  {title: 'Регистрация', src: 'registration'},
  {title: 'Стоимость', src: 'prices'},
  {title: 'Поддержка', src: 'support'},
];